import { Layout } from "antd";
import React, { useEffect } from "react";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router";
import { Outlet } from "react-router-dom";
import { autoOasisLogin, speedMateLogin } from "../../apis/Login/apis";
import { ModalNotice } from "../../components/organisms/Notice/Modal";
import useSpecial from "../../hooks/useSpecial";
import useUsers from "../../hooks/useUsers";
import {
  PATH,
  autoOasisCodeQuery,
  autoOasisCodeString,
  speedMateCodeString,
  speedMateQuery,
} from "../constants/path";

const SpecialRoute: React.FC = () => {
  const location = useLocation();
  const { signIn } = useUsers();
  const { setSpecial } = useSpecial();
  const nav = useNavigate();

  const specialCode: string | undefined =
    location.search?.includes(speedMateCodeString) ||
    location.search?.includes(autoOasisCodeString)
      ? location
        ? location?.search
            ?.split("&")
            ?.find(
              (text) =>
                text.includes(speedMateCodeString) ||
                text.includes(autoOasisCodeString)
            )
            ?.split("=")[1]
        : undefined
      : undefined;

  const singInSpeedMateMutation = useMutation(speedMateLogin, {
    onSuccess: (res) => {
      if (res.accessToken) {
        signIn(res.admin, res.accessToken);
        setSpecial(`${speedMateQuery}=${specialCode}`);
        nav(`${PATH.SPEED_MATE_RESERVATION + speedMateQuery}=${specialCode}`);
      }
    },
    onError: () => {},
  });
  const singInAutoOasisMutation = useMutation(autoOasisLogin, {
    onSuccess: (res) => {
      if (res.accessToken) {
        signIn(res.admin, res.accessToken);
        setSpecial(`${autoOasisCodeQuery}=${specialCode}`);
        nav(
          `${PATH.AUTO_OASIS_RESERVATION + autoOasisCodeQuery}=${specialCode}`
        );
      }
    },
    onError: () => {},
  });
  useEffect(() => {
    setSpecial("");
    if (specialCode) {
      if (location.search?.includes(speedMateCodeString))
        singInSpeedMateMutation.mutate({ repairShopCode: specialCode });

      if (location.search?.includes(autoOasisCodeString))
        singInAutoOasisMutation.mutate({ autooasisCode: specialCode });
    }
  }, []);

  return (
    <Layout style={{ overflowY: "hidden" }}>
      <ModalNotice />

      <Outlet />
    </Layout>
  );
};
export default SpecialRoute;
